<template>
  <div class="addClient">
    <div class="header">
      <div class="title">客源新增</div>
      <div class="closeIcon" @click="close"></div>
    </div>
    <div class="content">
      <div class="part1">
        <div class="oneLine">
        <div><span class="saleRent">购</span></div>
          <div class="mgLeft">姓名</div>
          <input type="text" class="input_150 mgLeft border" v-model="name">
          <select v-model="appellation">
            <option value="先生">先生</option>
            <option value="小姐">小姐</option>
            <option value="女士">女士</option>
          </select>
          <div class="mgX">手机</div>
          <input type="text" class="input_200 border" v-model="phone">
          <button class="check mgX">查</button>
        </div>
        <div class="oneLine">
          <div>其它联系方式</div>
          <input type="text" class="input_200 mgX" v-model="other_way">
          <div>来源</div>
          <input type="text" class="input_200 mgX border" v-model="from">
        </div>
        <div>需求：</div>
        <div class="oneLine">
          <div>位置</div>
          <input type="text" class="input_200 mgX border" v-model="position">
          <div>面积</div>
          <input type="text" class="input_100 mgX" v-model="square">
          <div>价格</div>
          <input type="text" class="input_100 mgX" v-model="price">
        </div>
        <div class="oneLine">
          <div>户型</div>
          <input type="text" class="input_200 mgX" v-model="room_count">
          <div>装修</div>
          <select class="mgLeft" v-model="decorate">
            <option value="毛坯">毛坯</option>
            <option value="清水">清水</option>
            <option value="简装">简装</option>
            <option value="精装">精装</option>
            <option value="豪装">豪装</option>
          </select>
        </div>
        <div class="oneLine">
          <div>需求提炼</div>
          <input type="text" class="input_500 mgX" v-model="need">
        </div>
      </div>
      <div class="part2">
        <button @click="save">保存</button>
        <button @click="close">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        price: '',
        decorate: '',
        name: '',
        appellation: '',
        phone: '',
        other_way: '',
        from: '',

        square: '',
        position: '',
        room_count: '',
        need: ''
      }
    },
    mounted() {
    },
    methods: {
      close() {
        this.$emit('childOper', {
          from: 'addClient',
          oper: 'close'
        })
      },
      save() {
        let that = this
        if (!that.position || !that.name || !that.phone) {
          console.log('没有填完整')
          return
        }
        let obj = {
          square: that.square,
          from: that.from,
          price: that.price,
          name: that.name,
          appellation: that.appellation,
          phone: that.phone,
          other_way: that.other_way,
          room_count: that.room_count,
          decorate: that.decorate,
          need: that.need,
          position: that.position
        }
        let param = {
          'db': 'ClientModel',
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (res) {
          console.log('上传返回', res)
          that.$emit('childOper', {
            from: 'addClient',
            oper: 'refresh'
          })
          that.close()
        }).catch(function (res) {
          console.log('上传失败', res)
        })
      },

    }
  }

</script>

<style scoped>
  input {
    outline: none;
  }

  .mgLeft {
    margin-left: 3px;
  }

  .mgX {
    margin: 0 3px;
  }

  select {
    padding: 1px 3px;
    outline: none;
    background-color: white;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -khtml-border-radius: 0;
    -webkit-appearance: none;
  }



  .addClient {
    width: 400px;
    position: fixed;
    z-index: 5;
    box-shadow: 0px 0px 10px rgb(50, 50, 50);
    overflow: hidden;
    font-size: 15px;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-60%);
    background-color: white;
  }

  .header {
    background-color: skyblue;
    display: flex;
    padding: 8px;
    justify-content: space-between;
  }

  .title {
    font-weight: 500;
  }

  .closeIcon {
    width: 16px;
    height: 16px;
    background: url('../../static/images/close.png') 0 0 no-repeat;
  }

  .content {
    padding: 8px;
    line-height: 25px;
  }

  .oneLine {
    display: flex;
    align-items: center;
  }

  .saleRent {
    color: white;
    background-color: orange;
    padding: 3px;
    border-radius: 4px;
  }

  .check {
    background-color: orange;
    outline: none;
    padding: 2px;
  }

  .part2 {
    margin-top: 10px;
    border-top: 1px solid skyblue;
    text-align: center;
  }

  .part2 button {
    padding: 3px 10px;
    margin: 10px;
    border-radius: 5px;
    background-color: skyblue;
    outline: none;
  }


  .input_100 {
    width: 50px;
    height: 15px;
  }

  .input_150 {
    width: 75px;
    height: 15px;
  }

  .input_200 {
    width: 100px;
    height: 15px;
  }

  .input_500 {
    width: 250px;
    height: 15px;
  }

  .border {
    border: 1px solid orange;
    height: 17px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AddClient.vue